import { makeStyles } from '@mui/styles';
import theme from 'src/theme';
export const useStyles = makeStyles(() => ({
  root: {
    padding: `0 ${theme.spacing(4)}`,
  },
}));
